import React from 'react';

export const NoneIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
			<circle cx="15" cy="15" r="14" fill="white" stroke="#F50057" stroke-width="2" />
		</svg>
	);
};
